module.exports = __webpack_public_path__ + "img/IMG_7101.61f21c37.webp";